"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const map_service_1 = require("../../../commons/map.service");
class ScreenshotComponent {
    constructor(mapService) {
        this.mapService = mapService;
        this.takingScreenShot = false;
        this.timeout = 10000; // in ms
    }
    takeScreenShotForVolume() {
        // configure settings
        this.takingScreenShot = true;
        // define callback functions
        this.prepareScreenshotFunction = this.prepareScreenshot.bind(this);
        this.mapService.viewer.scene.preRender.addEventListener(this.prepareScreenshotFunction);
    }
    prepareScreenshot() {
        var canvas = this.mapService.viewer.scene.canvas;
        this.mapService.viewer.scene.preRender.removeEventListener(this.prepareScreenshotFunction);
        // take snapshot after defined timeout to allow scene update (ie. loading data)
        setTimeout(() => {
            this.takeScreenshotFunction = this.takeScreenshot.bind(this);
            this.mapService.viewer.scene.postRender.addEventListener(this.takeScreenshotFunction);
        }, this.timeout);
    }
    takeScreenshot() {
        this.mapService.viewer.scene.postRender.removeEventListener(this.takeScreenshotFunction);
        var canvas = this.mapService.viewer.scene.canvas;
        canvas.toBlob((blob) => {
            let downloadLink = document.createElement('a');
            downloadLink.href = window.URL.createObjectURL(blob);
            downloadLink.setAttribute('download', 'Screenshot ' + new Date() + '.png');
            document.body.appendChild(downloadLink);
            downloadLink.click();
            this.takingScreenShot = false;
        });
    }
}
exports.ScreenshotComponent = ScreenshotComponent;
